export function SideClose() {
    return(
        <label htmlFor="side-toggle" className="btn d-lg-none side-toggle btn-close"></label>
    )
}